


















































import mixins from 'vue-typed-mixins'
import linkAdsListMixin from '@/components/Mixins/linkAdsList'

export default mixins(linkAdsListMixin<TopWelfareCard>()).extend({
  props: {
    singleItem: Object,
    index: Number,
    PVIformat: String,
    clickIformat: String
  },
  mounted() {
    this.reportAdsPV(this.index, {
      groupId: this.singleItem?.groupId_busId.split('_')[0]
    }, this.PVIformat)
  },
  methods: {
    jumpToActivity() {
      this.reportAdsPV(this.index, {
        groupId: this.singleItem?.groupId_busId.split('_')[0]
      }, this.clickIformat)
      if (this.singleItem.url) {
        window.location.href = this.singleItem.url
      }
    }
  }
})
